/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type {
  LogiumV2Core,
  LogiumV2CoreInterface,
  Constants,
} from "../../contracts/LogiumV2Core";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "contract IERC20",
            name: "USDC",
            type: "address",
          },
        ],
        internalType: "struct Constants.ConstantsStruct",
        name: "constants",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "previousAdmin",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAdmin",
        type: "address",
      },
    ],
    name: "AdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "beacon",
        type: "address",
      },
    ],
    name: "BeaconUpgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "newLimit",
        type: "uint128",
      },
    ],
    name: "ChangeWithdrawLimit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
    ],
    name: "Deposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
    ],
    name: "MarketMakerAccountGains",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "int128",
        name: "change",
        type: "int128",
      },
    ],
    name: "MarketMakerBalanceChange",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
    ],
    name: "MarketMakerDeposit",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "newVault",
        type: "address",
      },
    ],
    name: "MarketMakerVaultChange",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
    ],
    name: "MarketMakerWithdrawVault",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "implementation",
        type: "address",
      },
    ],
    name: "Upgraded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
    ],
    name: "Withdraw",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
    ],
    name: "WithdrawLimitRefill",
    type: "event",
  },
  {
    inputs: [],
    name: "APPROVER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MARKET_MAKER_MANAGER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MARKET_MAKER_WITHDRAW_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UPGRADER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "WITHDRAW_LIMIT_MANAGER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddr",
        type: "address",
      },
    ],
    name: "balance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newMarketMakerVault",
        type: "address",
      },
    ],
    name: "changeMarketMakerVault",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "newLimit",
        type: "uint128",
      },
    ],
    name: "changeWithdrawLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "target",
        type: "address",
      },
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
    ],
    name: "depositTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
    ],
    name: "depositToMarketMaker",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "approver",
        type: "address",
      },
      {
        internalType: "address",
        name: "marketMakerManager",
        type: "address",
      },
      {
        internalType: "address",
        name: "withdrawManager",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
    ],
    name: "marketMakerAccountGains",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "marketMakerBalance",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "marketMakerVault",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "proxiableUUID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "resetWithdrawLimit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "users",
    outputs: [
      {
        internalType: "uint128",
        name: "totalDeposit",
        type: "uint128",
      },
      {
        internalType: "uint128",
        name: "totalWithdraw",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "user",
            type: "address",
          },
          {
            internalType: "uint128",
            name: "approvedTotalWithdraw",
            type: "uint128",
          },
          {
            internalType: "uint64",
            name: "expiry",
            type: "uint64",
          },
        ],
        internalType: "struct ILogiumV2Core.WithdrawApproval",
        name: "approval",
        type: "tuple",
      },
      {
        internalType: "bytes",
        name: "signature",
        type: "bytes",
      },
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawLimitFillDay",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawLimitLastFill",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawLimitLeft",
    outputs: [
      {
        internalType: "uint128",
        name: "",
        type: "uint128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
    ],
    name: "withdrawMarketMakerFunds",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint128",
        name: "amount",
        type: "uint128",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "withdrawMarketMakerFundsTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type LogiumV2CoreConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: LogiumV2CoreConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class LogiumV2Core__factory extends ContractFactory {
  constructor(...args: LogiumV2CoreConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    constants: Constants.ConstantsStructStruct,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<LogiumV2Core> {
    return super.deploy(constants, overrides || {}) as Promise<LogiumV2Core>;
  }
  override getDeployTransaction(
    constants: Constants.ConstantsStructStruct,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(constants, overrides || {});
  }
  override attach(address: string): LogiumV2Core {
    return super.attach(address) as LogiumV2Core;
  }
  override connect(signer: Signer): LogiumV2Core__factory {
    return super.connect(signer) as LogiumV2Core__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LogiumV2CoreInterface {
    return new utils.Interface(_abi) as LogiumV2CoreInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LogiumV2Core {
    return new Contract(address, _abi, signerOrProvider) as LogiumV2Core;
  }
}
